import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const PayBill00Table: GenericTableSchemaInterface = {
  id: "paybill-00",
  name: "Pay Bill Funnel 00",
  description: "This table contains data regarding how many people we navigate to online bill pay.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Pay Bill Start"
    },
    c04: {
      name: "Pay by Phone"
    },
    c05: {
      name: "Pay Online"
    },
    c06: {
      name: "Navigate to Login"
    },
    c07: {
      name: "Navigate to Online Bill Pay Page"
    },
    c08: {
      name: "spot.is Payment Link Error"
    }
  }
};
